import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {iPurchaseBill,iPurchaseBillResponse} from '../../../services/api/api'
// Models



// Materials state
interface iBill {[key:number]:iPurchaseBillResponse[]|null}

export interface billState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    showBill: boolean,
    bill?: iPurchaseBill,
    bills: iBill,
    page:number,

}

const initialMaterialsState: billState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    showBill: false,
    bill: undefined,
    bills: {
    },
    page:1,
    
}

// Users slice
export const purchaseBillSlicer = createSlice({
    name: 'purchaseBill',
    initialState: initialMaterialsState,
    reducers: {
        init:(state,{payload}:PayloadAction<iPurchaseBillResponse[]>)=>{
            state.bills[state.page]=payload
        },
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        setBill: (state, { payload }: PayloadAction<{ showOrder: boolean, bill?: iPurchaseBill }>) => {
          
            state.showBill = payload.showOrder
                state.bill = payload.bill
        },
        addBill: (state, { payload }: PayloadAction<iPurchaseBillResponse[]>) => {
       
            state.bills [state.page]=    state.bills [state.page]?
            [ ...(state.bills [state.page]??[]),...payload]:[...payload]
        
        },
        updateBill: (state, { payload }: PayloadAction<iPurchaseBillResponse>) => {
            let index =    state.bills[state.page]!.findIndex(order => order.id === payload.id)
            if (index !== -1)
            state.bills [state.page]![index] = payload
        },
        deleteBill: (state, { payload }: PayloadAction<number[]>) => {
            payload.map(id => {
                let index =    state.bills [state.page]!.findIndex(material => material.id === id)
                if (index&&index != -1)
                state.bills [state.page]!.splice(index, 1)
            })
        },
       
        reset: (state) => {
            state.bills = []
            state.hasMore = true
        },
        setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        },
       
    }
})